const selectedPageSize = localStorage.getItem("pageSize");
const DEFAULT_PAGE = 500;

const defaultPageSizes = {
  "/candidate-listing": 100,
  "/site-listing": 50,
  "/userManagement": 50,
  "/sts": 50
};

const ALL_CONSTANTS = {
  PAGE_ROUTES: {
    DEFAULT_ROUTE: "/",
    LOGIN_ROUTE: "/login",
    FORGET_PASSWORD_ROUTE: "/forget-password",
    CANDIDATE_LISTING_ROUTE: "/candidate-listing",
    SITE_LISTING_ROUTE: "/site-listing",
    DAILY_BOOKING_ROUTE: "/daily-booking",
    CANDIDATE_CALENDAR_ROUTE: "/candidate-calendar",
    MONTHLY_CALENDAR_ROUTE: "/monthly-calendar",
    WEEKLY_CALENDAR_ROUTE: "/weekly-calendar",
    CANDIDATE_PROFILE_ROUTE: "/candidate-profile",
    SITE_PROFILE_ROUTE: "/site-profile",
    MANAGE_PAY_RATES_ROUTE: "/manage-pay-rates",
    DOCUMENTS_ROUTE: "/document",
    SYSTEM_SETUP_ROUTE: "/system-setup",
    STS_ROUTE: "/sts",
    USER_MANAGEMENT_ROUTE: "/userManagement",
    GENERATE_PAYRATE_ROUTE: "/generate-payDocument",
    HOLIDAY_ROUTE: "/holiday",
    VERIFY_BOOKING_ROUTE: "/Verify-booking",
    CLIENT_MANAGEMENT_ROUTE: "/client-management",
    REPORTS_ROUTE: "/reports",
    REQUEST_PASSWORD_RESET_ROUTE: "/request-password-reset",
    COMPLETE_PASSWORD_RESET_ROUTE: "/completepwreset",
    COST_ANALYSIS_ROUTE: "/cost-analysis",
    INFRINGEMENT_ROUTE: "/infringement",
    CANDIDATE_PERFORMANCE_ROUTE: "/candidate-performance",
    NOT_FOUND_ROUTE: "/404",
    NO_ACCESS_ROUTE: "/403",
    NOT_AUTH_ROUTE: "/401",
  },
  HTTP_REQ_DEFAULT_HEADERS: {
    Accept: "application/json",
    "Content-Type": "application/json; charset=UTF-8"
  },
  HTTP_MULTIPART_FORM_HEADERS: {
    "Content-Type": "multipart/form-data"
  },
  DATE_FORMAT: {
    FORMAT_DEFAULT: "DD-MM-YYYY",
    DRS_DATE_FORMAT: "DD/MM/YYYY",
    FORMAT_2: "DD/MM/YYYY",
    FORMAT_3: "MMM/YYYY",
    FORMAT_4: "DD/MM/YY"
  },
  TIME_FORMAT: "HH:mm:ss",
  ONLY_MINUTE: "HH:mm",
  ONLY_HOUR: "HH",
  DATE_FORMAT_STRING: "YYYY-MM-DD",
  API_ERROR_MSG: "Internal Server Error",
  API_TIME_OUT: 300000,
  MODAL_ZINDEX: 1800,
  DEFAULT_MODAL_WIDTH: "75%",
  NULLIFY: null,
  HTTP_REQUEST_METHODS: {
    POST: "POST",
    GET: "GET",
    DELETE: "DELETE",
    PATCH: "PATCH",
    PUT: "PUT"
  },
  API_MSG_TIME: 5,
  API_MSG_PLACEMENT: 85,
  API_SUCCESS_INFO: "Action Complete",
  API_ERROR_INFO: "Action Failed",
  API_SUCCESS: "success",
  API_ERROR: "error",
  HTTP_STATUS: {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORISED: 401,
    FORBIDDEN: 403,
    METHOD_NOT_FOUND: 404,
    METHOD_NOT_ALLOWED: 405,
    UNPROCESSABLE: 422,
    INTERNAL_SERVER_ERROR: 500,
    NOT_IMPLEMENTED: 501
  },
  CANDIDATE_STATUS: [
    { Name: "Unprocessed", ObjectId: "5" },
    { Name: "Processed", ObjectId: "1" },
    { Name: "DoNotUse", ObjectId: "2" },
    { Name: "Inactive", ObjectId: "3" },
    { Name: "Active", ObjectId: "4" }
  ],

  PAYMENT_TIER: [
    { Name: "PAYE", ObjectId: "1" },
    { Name: "LTD", ObjectId: "2" },
    { Name: "Second Tier", ObjectId: "3" }
  ],

  SITE_STATUS: [
    { Name: "Processed", ObjectId: "1" },
    { Name: "DoNotUse", ObjectId: "2" },
    { Name: "Inactive", ObjectId: "3" },
    { Name: "Active", ObjectId: "4" },
    { Name: "Unprocessed", ObjectId: "5" },
    { Name: "Deleted", ObjectId: "6" }
  ],
  USER_STATUS: [
    { Name: "Inactive", ObjectId: "1" },
    { Name: "Active", ObjectId: "2" }
  ],
  BOOKING_CANCEL_REASON: [
    { label: "No Cover", value: "NoCover" },
    { label: "Input Error", value: "InputError" },
    { label: "Candidate Sick", value: "CandidateSick" },
    { label: "Candidate No Show", value: "NoShow" },
    { label: "Candidate Cancelled", value: "Candidate" },
    { label: "Client Covered", value: "ClientCovered" },
    { label: "Client Cancelled", value: "Client" },
    { label: "Incorrect Forecast", value: "IncorrectForecast" }
  ],
  CLIENT_BOOKING_CANCEL_REASON: [{ label: "Client Cancelled", value: "Client" }],
  SESSION_EXPIRED: "Your Session has Expired. Please log back in.",
  DEFAULT_PAGINATION_OBJECT: {
    position: ["bottomCenter"],
    defaultPageSize: selectedPageSize || DEFAULT_PAGE,
    pageSizeOptions: [10, 20, 50, 100, 500],
    hideOnSinglePage: true,
    onShowSizeChange: (current, size, pathname = null) => {
      if (pathname) {
        let pageSize = localStorage.getItem("pageSizeProps") || "{}";

        const newPageSize = JSON.stringify({ ...JSON.parse(pageSize), [pathname]: size });

        localStorage.setItem("pageSizeProps", newPageSize);
      }
    },
    getDefaultPageSize(pathname) {
      if (pathname) {
        const pageSize = localStorage.getItem("pageSizeProps");

        if (pageSize) {
          return JSON.parse(pageSize)[pathname] || defaultPageSizes[pathname];
        }
        return defaultPageSizes[pathname];
      }

      return defaultPageSizes[pathname];
    }
  },
  DEFAULT_WEEKLY_BOOKING_PAGINATION_OBJECT: {
    position: ["bottomCenter"],
    defaultPageSize: 500,
    pageSizeOptions: [10, 20, 50, 100, 500],
    hideOnSinglePage: true
  }
};

const CONSTANTS = Object.freeze(ALL_CONSTANTS);

export default CONSTANTS;
